<template>
    <div class="mainpage">
        <div v-if="subscription" class="subcription-text">
            <p>Your Subscription to the URL shortening service has been successfully activated !</p>
            <p>Validity : 8th September 2024</p>
        </div>
        <div v-else class="subcription-text">
            <p>Please enable subscription to use URL shortneing features !</p>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapModels } from '@/utils'

export default {
    name: 'Subscription',
    components: {
    },
    data () {
        return {
        }
    },
    methods: {
        async logout () {
            await this.$store.dispatch('unsetUser')
            this.$router.push('/signin')
        }
    },
    computed: {
        ...mapModels('general', ['globalLoader', 'subscription'])
    },
    mounted () {
    }
}

</script>

<style scoped>
.subcription-text {
    padding: 2rem;
    background-color: white;
    border-radius: 1rem;
    min-height: 30vh;
}

</style>
